import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  min-height: 100vh;
  width: 100vw;
  max-width: 100%;
  display: grid;
  grid-template-columns: 400px 2fr;
  grid-template-rows: 100%;

  @media screen and (max-width: 950px) {
    grid-template-columns: 1fr;
    grid-template-rows: 400px auto;
  }
`;

export const LoadingContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;
